function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  height: 499px;\n  width: 550px;\n  padding: 0;\n  z-index: 100;\n\n  @media ",
        " {\n    max-width: 350px;\n    height: 551px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 26px;\n  padding: 22px 0;\n  display: block;\n  font-weight: bold;\n\n  color: var(--dcm-color-text-primary, ",
        ");\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  margin: 0 100px 36px;\n  padding-top: 50px;\n\n  @media ",
        " {\n    margin: 0 30px 45px;\n    padding-top: 41px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin: 9px auto 19px;\n  font-size: 12px;\n  width: 153px;\n  height: 39px;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  color: #6d747b;\n  font-size: 13px;\n  line-height: 24px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  padding-bottom: 20px;\n  font-size: 12px;\n  text-align: center;\n  line-height: 165%;\n\n  color: ",
        ";\n\n  @media ",
        " {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Text } from 'rebass/styled-components';
import { space, width, fontSize } from 'styled-system';
import { mediaQueries } from 'shared/styles';
import useStores from 'shared/hooks/use-stores';
import { Button, StyledLink, DesktopOnly, MobileOnly } from 'shared/components';
import { ModalContainer } from 'shared/modals/v2-container';
import { RewardsRibbon, RibbonColorPallettes } from 'shared/assets/rewards-ribbon';
var AlpineIQTerms = /*#__PURE__*/ forwardRef(function(param, ref) {
    var onAgree = param.onAgree, onDecline = param.onDecline, containerProps = param.containerProps;
    var Cart = useStores().Cart;
    var dispensary = Cart.order.dispensary;
    if (!dispensary) {
        return;
    }
    // eslint-disable-next-line consistent-return
    return /*#__PURE__*/ _jsx(StyledModalContainer, _object_spread_props(_object_spread({
        ref: ref,
        mobileCentered: true,
        isOpen: true
    }, containerProps), {
        children: /*#__PURE__*/ _jsxs(ModalContent, {
            id: "asdfasdf",
            children: [
                /*#__PURE__*/ _jsx(DesktopOnly, {
                    children: /*#__PURE__*/ _jsx(RewardsRibbon, {
                        pallette: RibbonColorPallettes.blue,
                        height: 106,
                        width: 106
                    })
                }),
                /*#__PURE__*/ _jsx(MobileOnly, {
                    children: /*#__PURE__*/ _jsx(RewardsRibbon, {
                        pallette: RibbonColorPallettes.blue,
                        height: 86,
                        width: 86
                    })
                }),
                /*#__PURE__*/ _jsx(TitleText, {
                    children: "Terms of Use"
                }),
                /*#__PURE__*/ _jsxs(TermsText, {
                    children: [
                        "I consent to signup for the ",
                        dispensary.name,
                        " ",
                        Cart.rewardsProgramDisplayName,
                        " program where I will receive marketing communications. By doing so, I understand that I am allowing ",
                        dispensary.name,
                        ' and its technology provider(s) to retain my personal contact details/engagement history for use in personalized marketing. Opt out at any time by replying "STOP" to messages. Standard message and calling rates may apply.'
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledAgreeButton, {
                    id: "alpineIqAgreeToTermsButton",
                    onClick: onAgree,
                    "data-cy": "save-button",
                    "data-test": "save-button",
                    children: "Agree & Continue"
                }),
                /*#__PURE__*/ _jsx(StyledLink, {
                    as: "button",
                    fontSize: "13px",
                    onClick: onDecline,
                    children: "No thanks, not now"
                })
            ]
        })
    }));
});
export default AlpineIQTerms;
var modalContainerStyles = css(_templateObject(), mediaQueries.largeTablet);
var StyledModalContainer = styled(ModalContainer)(_templateObject1(), modalContainerStyles);
var TitleText = styled(Text)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBlack;
});
var ModalContent = styled.div(_templateObject3(), mediaQueries.largeTablet);
var StyledAgreeButton = styled(Button)(_templateObject4());
var CheckoutText = styled(Text)(_templateObject5(), space, width, fontSize);
var TermsText = styled(CheckoutText)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[35];
}, mediaQueries.largeTablet);
